import React, { useState, useEffect } from "react";
import { Url } from "../../url";
import './../../entrydoor.css';
import './DoorItems.css';

const Test = ({ value, onChange, label = "Panel Items" }) => {
    const [items, setItems] = useState(value || []);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetch(`${Url}/doorpanels`)
            .then((response) => response.json())
            .then((data) => {
                let filteredItems = data;
                setItems(filteredItems);
            })
            .catch((error) => {
                console.error("Error fetching items:", error);
                alert("An error occurred while fetching items.");
            });
    }, []);

    // Add onSelect handler
    const handleSelect = (item) => {
        setSelectedItem(item);
        // Pass the selected item to the parent via onChange
        if (onChange) {
            onChange(item);
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="Test">{label}</label>
            <div className="door-items-container">
                {Array.isArray(items) && items.length > 0 ? (
                    items.map((item) => (
                        <div
                            key={item.id}
                            className={`door-item ${selectedItem?.id === item.id ? 'selected' : ''}`}
                            onClick={() => handleSelect(item)} // Add click handler
                            style={{ cursor: 'pointer' }} // Optional: visual feedback
                        >
                            <img 
                                src={`images/${item.image}`} 
                                alt={item.value} 
                                aria-label={`Door item ${item.value}`}
                            />
                        </div>
                    ))
                ) : (
                    <p>No items available for the selected collection or grain filter.</p>
                )}
            </div>
        </div>
    );
};

export default Test;